import React from 'react';
import { NewLozenge } from '@atlassian/jira-business-onboarding-common';
import { PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG } from '../../common/constants';

const NewImporterLozenge = () => <NewLozenge flag={PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG} />;

export default NewImporterLozenge;
